import type { CategoryMeta } from "@/types/catalog";

export const categories: CategoryMeta[] = [
  {
    key: "movie",
    name: "电影",
    path: "/category/movie",
    description: "爱妻艺电影频道，涵盖最新、热门影视作品，满足多元观影需求。",
    icon: "ri-film-line",
  },
  {
    key: "tv",
    name: "电视剧",
    path: "/category/tv",
    description: "爱妻艺电视剧频道，汇聚热播剧集与口碑佳作，追剧不再剧荒。",
    icon: "ri-tv-2-line",
  },
  {
    key: "variety",
    name: "综艺",
    path: "/category/variety",
    description: "爱妻艺综艺频道，音乐、竞技、生活多品类综艺任你挑选。",
    icon: "ri-mic-line",
  },
];

export const regions = ["全部", "中国大陆", "中国香港", "中国台湾", "美国", "日本", "韩国"];

export const yearFilters = ["全部", "2025", "2024", "2023", "2022", "2021及更早"];

export const ratingFilters = ["全部", "9分以上", "8分以上", "7分以上", "7分以下"];